import MainPagesScrollController from 'components/MainPagesScrollController';
import PageMeta from 'components/PageMeta';
import { PageViewTrackerProvider } from 'context/PageViewTracker';
import { AnalyticsProvider } from 'hooks/useAnalytics';
import { LinguiI18nContextProvider } from 'hooks/useLinguiI18n';
import { BranchProvider } from 'lib/branch/BranchProvider';
import React, { Suspense } from 'react';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import GlobalRedirectWrapper from './GlobalRedirect/GlobalRedirectWrapper';
import Pages from './Pages';
import IntlPages from './IntlPages';
import { ABTestProvider } from 'context/ABTestContext';
import { AuthPopupProvider } from 'hooks/useAuthPopup';
import { NotificationProvider } from 'hooks/useNotification';
import { GetAppPopupProvider } from 'hooks/useGetAppPopup';
import RouteChangeHandler from 'components_v2024/RouteChangeHandler';
import { isDevelopmentRoute } from './isDevelopmentRoute';

const Routes: React.FC<{}> = () => {
  return (
    <BrowserRouter>
      <RouteChangeHandler />
      <GlobalRedirectWrapper>
        <MainPagesScrollController />
        <AnalyticsProvider>
          <BranchProvider>
            <ABTestProvider>
              <PageViewTrackerProvider>
                <PageMeta />
                <LinguiI18nContextProvider>
                  <Suspense fallback={<></>}>
                    <Switch>
                      <Route
                        exact
                        path={[
                          '/privacy-policy',
                          '/privacypolicy_separate',
                          '/privacypolicy',
                          '/privacy'
                        ]}
                        render={() => {
                          return <Redirect to="/legal/privacy-policy" />;
                        }}
                      />
                      <Route
                        exact
                        path={['/terms-of-service', '/terms']}
                        render={() => {
                          return <Redirect to="/legal/terms-of-service" />;
                        }}
                      />
                      <Route>
                        <AuthPopupProvider>
                          <NotificationProvider>
                            <GetAppPopupProvider>
                              <Suspense fallback={<></>}>
                                <Switch>
                                  <Route
                                    path="/:lang(br|es|es-es|es-mx|de|de-de|de-ch|fr|fr-fr|fr-ca|nl|it)"
                                    component={IntlPages}
                                  />

                                  {isDevelopmentRoute() && (
                                    <Route
                                      path="/:lang(ru)"
                                      component={IntlPages}
                                    />
                                  )}

                                  <Route path="/" component={Pages} />
                                </Switch>
                              </Suspense>
                            </GetAppPopupProvider>
                          </NotificationProvider>
                        </AuthPopupProvider>
                      </Route>
                    </Switch>
                  </Suspense>
                </LinguiI18nContextProvider>
              </PageViewTrackerProvider>
            </ABTestProvider>
          </BranchProvider>
        </AnalyticsProvider>
      </GlobalRedirectWrapper>
    </BrowserRouter>
  );
};

export default Routes;
